import { useEffect, useState } from 'react'

import connectionMonitor, { INITIAL_CONNECTION_STATE } from '../services/connection-monitor.service'
import type { ConnectionMonitorService, ConnectionState } from '../services/connection-monitor.service'

export const useConnectionStatus = (
    enabled: boolean,
    monitor: Pick<ConnectionMonitorService, 'subscribe' | 'start' | 'stop'> = connectionMonitor,
) => {
    const [state, setState] = useState<ConnectionState>(INITIAL_CONNECTION_STATE)

    useEffect(() => {
        if (!enabled) {setState(INITIAL_CONNECTION_STATE); return}
        const unsubscribe = monitor.subscribe(setState)
        void monitor.start()
        return () => {unsubscribe(); monitor.stop()}
    }, [enabled, monitor])

    return enabled ? state : INITIAL_CONNECTION_STATE
}
